export interface Size {
  width: number;
  height: number;
}

export function sizeString(width: number, height: number): string {
  return `{ width: ${width} height: ${height}}`;
}

export function sizeObjectString(size: Size): string {
  return sizeString(size.width, size.height);
}

export function sizeEquals(
  a: Size | null | undefined,
  b: Size | null | undefined,
): boolean {
  if (!a || !b) {
    return false;
  } else if (a === b) {
    return true;
  } else if (a.width === b.width && a.height === b.height) {
    return true;
  } else {
    return false;
  }
}
